import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchUserProfile, fetchUsersList, updateUserProfile } from 'api/users';
import { useAuth } from './useAuth';
import { matchPath, useLocation } from 'react-router-dom';
import { AdminRouteList, RouteList } from 'types';

export const useUsers = () => {
  const { user: currentUser } = useAuth();
  const { pathname } = useLocation();
  const isGa4ConfigPage = !!matchPath({ path: RouteList.Ga4Config }, pathname);

  const shouldShowUserListByRoute =
    !!matchPath({ path: AdminRouteList.Campaigns }, pathname) || !!matchPath({ path: AdminRouteList.Users }, pathname);

  const userProfileQuery = useQuery({
    queryKey: ['userProfile'],
    queryFn: () => fetchUserProfile(),
    enabled: !isGa4ConfigPage,
  });
  const updateUserProfileQuery = useMutation({
    mutationFn: updateUserProfile,
    onSuccess: () => userProfileQuery.refetch(),
  });
  const usersListQuery = useQuery({
    queryKey: ['usersList'],
    queryFn: () => fetchUsersList(),
    enabled: !!currentUser?.isAdministrator && shouldShowUserListByRoute,
  });
  return { userProfileQuery, updateUserProfileQuery, usersListQuery, currentUser };
};
